import { useRecoilValue } from "recoil";
import { subscriptionPlanNameStore } from "@store/subscriptionPlanName";

/**
 * True when the current user is on the Freemium plan. The plan surfaces via
 * GetUserDetail.subscriptionPlanName; per the MS-407 backend contract the exact
 * English string is "Freemium" (do NOT localize this comparison).
 */
export const useIsFreemium = (): boolean => {
  const planName = useRecoilValue(subscriptionPlanNameStore);
  return planName === "Freemium";
};
